// File: frontend/src/components/ums/UserStatsCards.js

import React from 'react';
import { Users, UserCheck, UserPlus } from 'lucide-react';
import styles from './UserStatsCards.module.css';

const UserStatsCards = ({ stats, isLoading }) => {
  if (isLoading) {
    return (
      <div className={styles.statsGrid}>
        {[1, 2, 3].map((i) => (
          <div key={i} className={`${styles.statCard} ${styles.loading}`}>
            <div className={styles.skeletonIcon}></div>
            <div className={styles.skeletonText}></div>
            <div className={styles.skeletonValue}></div>
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  const cards = [
    {
      label: 'Last 24 Hours',
      value: stats['24h']?.total || 0,
      detail: `${stats['24h']?.authenticated || 0} authenticated, ${stats['24h']?.anonymous || 0} anonymous`,
      icon: Users,
      color: 'primary'
    },
    {
      label: 'Last 7 Days',
      value: stats['7d']?.total || 0,
      detail: `${stats['7d']?.sign_ups || 0} sign-ups`,
      icon: UserPlus,
      color: 'success'
    },
    {
      label: 'Last 30 Days',
      value: stats['30d']?.total || 0,
      detail: `${stats['30d']?.activated_accounts || 0} activated accounts`,
      icon: UserCheck,
      color: 'info'
    }
  ];

  return (
    <div className={styles.statsGrid}>
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div key={index} className={styles.statCard}>
            <div className={`${styles.iconWrapper} ${styles[`icon${card.color.charAt(0).toUpperCase() + card.color.slice(1)}`]}`}>
              <Icon size={20} />
            </div>
            <div className={styles.statContent}>
              <div className={styles.statLabel}>{card.label}</div>
              <div className={styles.statValue}>{card.value.toLocaleString()}</div>
              <div className={styles.statDetail}>{card.detail}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserStatsCards;